import { Component, OnInit } from '@angular/core';
import { FinanceiroService } from '../../../../cadastro/services/financeiro.service';
import { Orcamento } from '../../../../cadastro/empresa/models/orcamento';

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent implements OnInit {
  loading = true;
  public colunas = ['Mês', 'Semana', 'Categoria', 'Valor', 'Data Início', 'Data Fim'];
  public linhas: any[] = [];

  constructor(private financeiroService: FinanceiroService) {}

  ngOnInit(): void {
    this.obterOrcamentos();
  }

  obterOrcamentos(): void {
    this.loading = true;
    const dataAtual = new Date();
    const primeiroDiaMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1).toISOString();

    this.financeiroService.obterOrcamentos(primeiroDiaMes).subscribe({
      next: (response) => {
        if (response.sucesso) {
          this.linhas = response.dados.map((orcamento: Orcamento) => [
            orcamento.mes,
            orcamento.semana,
            orcamento.categoria,
            orcamento.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            new Date(orcamento.dataInicio).toLocaleDateString('pt-BR'),
            new Date(orcamento.dataFim).toLocaleDateString('pt-BR')
          ]);
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
